import { render, staticRenderFns } from "./ClientesProveedores.vue?vue&type=template&id=2d849be0&scoped=true"
import script from "./ClientesProveedores.vue?vue&type=script&lang=js"
export * from "./ClientesProveedores.vue?vue&type=script&lang=js"
import style0 from "./ClientesProveedores.vue?vue&type=style&index=0&id=2d849be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d849be0",
  null
  
)

export default component.exports